<template>
    <div v-if="isOpen" class="overlay">
        <div class="browser-window">
            <div class="app-header">
                <button @click="closeOverlay" class="close-button">sluiten</button>
            </div>
            <!-- <div class="tab-bar">
                <div class="tab">
                    <span>{{ pageTitle }}</span>
                </div>
            </div> -->
            <div v-if="isImage" class="image-view">
                <img :src="currentFile" alt="">
            </div>
            <iframe v-else :src="currentURL" frameborder="0"></iframe>
            <button v-if="currentIndex > 0" @click="go(-1)" class="arrow arrow-prev">&#10094;</button>
            <button v-if="currentIndex < attachments.length - 1" @click="go(1)" class="arrow arrow-next">&#10095;</button>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        isOpen: {
            type: Boolean,
            default: false,
        },
        attachments: {
            type: Array,
            default: () => [],
        },
        startIndex: {
            type: Number,
            default: 0,
        },
        pageTitle: {
            type: String,
            default: "Tab",
        }
    },
    data() {
        return {
            currentIndex: 0,
        };
    },
    computed: {
        currentFile() {
            return this.attachments[this.currentIndex] || '';
        },
        currentURL() {
            return this.currentFile + '#toolbar=0&navpanes=0';
        },
        isImage() {
            return /\.(png|jpe?g|gif|webp|svg|bmp)$/i.test(this.currentFile);
        },
    },
    watch: {
        isOpen(open) {
            if (open) {
                this.currentIndex = this.startIndex;
            }
        },
    },
    methods: {
        closeOverlay() {
            this.$emit("close");
        },
        go(step) {
            this.currentIndex += step;
        },
    },
};
</script>

<style scoped>
.overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.8);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
    /* pointer-events: all; */
}

.browser-window {
    width: 80%;
    height: 80%;
    background: white;
    position: relative;
    border-radius: 10px;
    box-shadow: 4px 1px 35px rgba(0,0,0,0.9);
}

/* .browser-window,
.browser-window * {
    pointer-events: auto;
} */

.close-button {
    position: absolute;
    top: 0;
    right: 0;
    background-color: #e74c3c;
    color: white;
    border: none;
    padding: 7px 19px;
    border-radius: 7px;
    margin: 10px;
    cursor: pointer;
    transition: background-color 0.3s;

    /* Improving close button look */
    font-weight: bold;
    line-height: 1;
}

.close-button:hover {
    background-color: #c0392b;
}

.app-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0;
    background-color: #f5f5f5;
    /* border-bottom: 1px solid #ccc; */
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
}

.app-title {
    font-size: 16px;
    color: #333;
    display: none;
}

iframe, .image-view {
    width: 100%;
    height: 100%;
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
}

.image-view {
    overflow: auto;
    display: flex;
    justify-content: center;
    align-items: flex-start;
}

.image-view img {
    max-width: 100%;
    height: auto;
}

.arrow {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    width: 44px;
    height: 44px;
    border: none;
    border-radius: 50%;
    background-color: rgba(255, 255, 255, 0.9);
    color: #333;
    font-size: 24px;
    line-height: 1;
    cursor: pointer;
    box-shadow: 0 0 8px rgba(0, 0, 0, 0.5);
}

.arrow:hover {
    background-color: #fff;
}

.arrow-prev {
    left: -60px;
}

.arrow-next {
    right: -60px;
}

.tab-bar {
    background-color: #f5f5f5;
    padding: 0 10px;
    width: 100%;
    display: flex;
    border-bottom: 1px solid #e0e0e0;
}

.tab {
    /* flex: 1; */
    min-width: 10em;
    background-color: #fff;
    border: 1px solid #ccc;
    border-bottom: none;
    border-radius: 8px 8px 0 0;
    padding: 8px;
    text-align: center;
    box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.2);
    margin-bottom: 0;
    font-size: 16px;
    color: #333;
    cursor: pointer;
}
</style>
